import HttpService from 'services/HttpService';

export default class ShowsPickerService {
    constructor() {
        
        this.paths = {
            getCompilingPageAttrs: '/user-profile/xhr/compilingpage-attributes/'
        };

        this.http = new HttpService();
        this.http.regionBaseUrl = CBS.Registry.region.prefix;
    }

    getCompilingPageAttributes() {
        return new Promise((resolve, reject) => {
            this.http
                .doGet(this.paths.getCompilingPageAttrs)
                .then((res) => {
                    resolve(res);
                })
                .catch((err) => {
                    reject(err);
                });
        });
    }
}
